<template>
  <div class="fds-rich-text-editor">
    <menu-bar
      v-if="editor"
      :editor="editor"
    />
    <editor-content :editor="editor" />
  </div>
</template>

<script setup lang="js">
import { onBeforeUnmount } from "vue";
import { EditorContent, useEditor } from "@tiptap/vue-3";
import { Document } from "@tiptap/extension-document";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text } from "@tiptap/extension-text";
import { HardBreak } from "@tiptap/extension-hard-break";
import { History } from "@tiptap/extension-history";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Underline } from "@tiptap/extension-underline";
import { Strike } from "@tiptap/extension-strike";
import { TextAlign } from "@tiptap/extension-text-align";
import { BulletList } from "./extensions/bulletList";
import { ListItem } from "@tiptap/extension-list-item";
import { OrderedList } from "./extensions/orderedList";
import { Subscript } from "@tiptap/extension-subscript";
import { Superscript } from "@tiptap/extension-superscript";
import { TableRow } from "@tiptap/extension-table-row";
import MenuBar from "./MenuBar.vue";
import Table from "./table";
import TableHeader from "./table-header";
import TableCell from "./table-cell";
import TrailingNode from "./trailing-node";

const props = defineProps({ editorInput: String, editorOutput: HTMLInputElement });

const editor = useEditor({
  content: props.editorInput,
  extensions: [
    Document,
    Paragraph,
    Text,
    HardBreak,
    History,
    Bold,
    Italic,
    Underline,
    Strike,
    TextAlign.configure({
      types: ["paragraph"],
    }),
    BulletList,
    OrderedList,
    ListItem,
    Subscript,
    Superscript,
    Table,
    TableRow,
    TableHeader,
    TableCell,
    TrailingNode,
  ],
  editorProps: {
    attributes: {
      class: "fds-rich-text-editor__tiptap",
    },
  },
  parseOptions: {
    // The following must be set or `&nbsp;` will be inserted on lines which end with whitespace. When used with openhtmltopdf this breaks PDF rendering
    preserveWhitespace: true,
  },
  onUpdate: ({ editor }) => props.editorOutput.setAttribute("value", editor.getHTML()),
});

onBeforeUnmount(() => editor.value.destroy());
</script>
